import { useGoogleLogin } from "@react-oauth/google";
import { GoogleLogin } from "@react-oauth/google";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// We use Google Identity Services' button (no redirect URI needed) — it returns a
// credential JWT (ID token) directly to onSuccess which we POST to /api/auth/google.
// The backend verifies the token, links-or-creates the user, sets the mm_token cookie,
// and we refresh AuthContext from /api/auth/me.

const sanitizeNext = (raw, fallback) => {
  if (!raw || typeof raw !== "string") return fallback;
  if (!raw.startsWith("/") || raw.startsWith("//")) return fallback;
  return raw;
};

const GoogleSignInButton = ({ label = "signin_with" }) => {
  const { handleGoogleCredential } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const nextPath = sanitizeNext(searchParams.get("next"), "/dashboard");

  const onSuccess = async (response) => {
    if (!response?.credential) {
      toast.error("Google did not return a credential.");
      return;
    }
    try {
      const data = await handleGoogleCredential(response.credential);
      const greeting = data.is_new ? "Welcome aboard!" : "Welcome back!";
      toast.success(greeting);
      navigate(nextPath, { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Google sign-in failed.");
    }
  };

  const onError = () => {
    toast.error("Could not start Google sign-in. Please try again.");
  };

  return (
    <div className="w-full flex justify-center" data-testid="google-signin-wrapper">
      <GoogleLogin
        onSuccess={onSuccess}
        onError={onError}
        text={label}            // "signin_with" | "signup_with" | "continue_with"
        theme="outline"
        size="large"
        shape="pill"
        width="320"
      />
    </div>
  );
};

export default GoogleSignInButton;

// Re-export so callers can do `import { useGoogleLogin } from '...'` if they ever need it.
export { useGoogleLogin };
